




































































import { editFactory } from '@/main/pages';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { openSelectList } from '@/main/router/routerPath';
import { NdCenik } from '@/modules/sklad/ndCenik';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		NdSkladSelectWithCheck: NdSklad.components.SelectWithCheck,
	},
	data() {
		return {
			ndNrChecked: false,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				ndSklad: `${this.storeUri}/${editMutations.PSEUDO_NAHRADY_ND_SKLAD_SELECT_MAPPER}`,
			};
		},
		ndskladFilter(): Record<string, any> {
			return {
				NdNr: this.NdNr,
				VyrobekndOzn: this.VyrobekndOzn,
				Text: this.Text,
			};
		},
		isNdSkladSelectDisabled(): boolean {
			return this.isViewMode;
		},
	},
	mounted() {
		if (!this.isCreateMode) {
			this.ndNrChecked = true;
		}
	},
	methods: {
		vyrobekndOznChange() {
			this.NdNr = null;
			this.Text = null;
			this.ndNrChecked = false;
		},
		onUpdateNdnr(val: string | null) {
			this.Text = null;
			this.NdNr = val;
			this.ndNrChecked = false;
		},
		async onKontrolaNdClick() {
			await openSelectList(NdCenik.name, {
				filter: this.ndskladFilter,
				afterRowSelection: ({ row }) => {
					this.NdNr = row.ND_NR;
					this.Text = row.TEXT;
					this.ndNrChecked = true;
				},
			});
		},
		async saveClick() {
			if (this.ndNrChecked) {
				this.save();
			} else {
				this.showErrorNotification(this.LocalizeChyboveHlasky('ZakazkandErrND'));
			}
		},
	},
});
